import { render, staticRenderFns } from "./productMakeModel.vue?vue&type=template&id=0f832050&scoped=true&"
import script from "./productMakeModel.vue?vue&type=script&lang=js&"
export * from "./productMakeModel.vue?vue&type=script&lang=js&"
import style0 from "./productMakeModel.vue?vue&type=style&index=0&id=0f832050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f832050",
  null
  
)

export default component.exports